import { HttpParams } from '@angular/common/http';

export function encodeURIParamsLegacy(value: string): string {
	const keyValuePairs = value.split('&');

	const modifiedPairs = keyValuePairs.map((pair) => {
		const [key, rawValue = ''] = pair.split('=');
		const encodedValue = encodeURIComponent(rawValue);
		return `${key}=${encodedValue}`;
	});

	return modifiedPairs.join('&');
}

type Primitive = string | number | boolean;
type ParamValue = Primitive | readonly Primitive[] | null | undefined;

type EncodableParams<T extends object> = { [K in keyof T]?: ParamValue };

export function encodeURIParams<T extends object>(params: EncodableParams<T>): string {
	let httpParams = new HttpParams();

	for (const [key, value] of Object.entries(params)) {
		if (value == null) continue;

		if (Array.isArray(value)) {
			for (const v of value) {
				httpParams = httpParams.append(key, String(v));
			}
		} else {
			httpParams = httpParams.set(key, String(value));
		}
	}

	return httpParams.toString();
}
